import React, { useState, useEffect, useCallback } from 'react';
import { Trash2, User } from 'lucide-react';
import { adminAPI } from '../../services/api';
import toast from 'react-hot-toast';

const AdminUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [total, setTotal] = useState(0);
  const [deleting, setDeleting] = useState(null);

  const fetchUsers = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await adminAPI.getUsers({ page, limit: 20 });
      setUsers(data.users);
      setPages(data.pages);
      setTotal(data.total);
    } catch { toast.error('Failed to load users'); }
    finally { setLoading(false); }
  }, [page]);

  useEffect(() => { fetchUsers(); }, [fetchUsers]);

  const handleDelete = async (id, name) => {
    if (!window.confirm(`Delete user "${name}"?`)) return;
    setDeleting(id);
    try {
      await adminAPI.deleteUser(id);
      toast.success('User deleted');
      fetchUsers();
    } catch { toast.error('Failed to delete user'); }
    finally { setDeleting(null); }
  };

  return (
    <div style={{ padding: '32px' }}>
      <div style={{ marginBottom: '32px' }}>
        <h1 style={{ fontFamily: 'var(--font-display)', fontSize: '36px', fontWeight: 400 }}>Customers</h1>
        <p style={{ color: 'var(--white-dim)', fontSize: '13px', marginTop: '4px' }}>{total} registered customers</p>
      </div>

      <div style={{ background: 'var(--dark-2)', border: '1px solid var(--border)', overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ borderBottom: '1px solid var(--border)' }}>
              {['CUSTOMER', 'EMAIL', 'JOINED', 'ACTIONS'].map(h => (
                <th key={h} style={{ fontSize: '10px', letterSpacing: '0.2em', color: 'var(--white-dim)', textAlign: 'left', padding: '14px 16px' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? [...Array(5)].map((_, i) => (
              <tr key={i}><td colSpan={4} style={{ padding: '16px' }}><div className="skeleton" style={{ height: '20px' }} /></td></tr>
            )) : users.map(u => (
              <tr key={u._id} style={{ borderBottom: '1px solid rgba(201,168,76,0.05)' }}
                onMouseEnter={e => e.currentTarget.style.background = 'rgba(201,168,76,0.03)'}
                onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
              >
                <td style={{ padding: '14px 16px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <div style={{ width: '36px', height: '36px', borderRadius: '50%', background: 'rgba(201,168,76,0.1)', border: '1px solid var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <User size={16} color="var(--gold)" />
                    </div>
                    <span style={{ fontSize: '13px' }}>{u.name}</span>
                  </div>
                </td>
                <td style={{ padding: '14px 16px', fontSize: '13px', color: 'var(--white-dim)' }}>{u.email}</td>
                <td style={{ padding: '14px 16px', fontSize: '12px', color: 'var(--white-dim)' }}>{new Date(u.createdAt).toLocaleDateString()}</td>
                <td style={{ padding: '14px 16px' }}>
                  <button onClick={() => handleDelete(u._id, u.name)} disabled={deleting === u._id}
                    style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '11px', color: '#ef4444', background: 'none', letterSpacing: '0.1em', cursor: 'pointer', opacity: deleting === u._id ? 0.5 : 1 }}>
                    <Trash2 size={12} /> DELETE
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {users.length === 0 && !loading && (
          <div style={{ textAlign: 'center', padding: '48px', color: 'var(--white-dim)' }}>
            <p style={{ fontFamily: 'var(--font-display)', fontSize: '22px' }}>No customers yet</p>
          </div>
        )}
      </div>

      {pages > 1 && (
        <div style={{ display: 'flex', justifyContent: 'center', gap: '8px', marginTop: '24px' }}>
          {[...Array(pages)].map((_, i) => (
            <button key={i} onClick={() => setPage(i + 1)}
              style={{ width: '36px', height: '36px', border: `1px solid ${page === i + 1 ? 'var(--gold)' : 'var(--border)'}`, background: page === i + 1 ? 'var(--gold)' : 'transparent', color: page === i + 1 ? 'var(--black)' : 'var(--white)', fontSize: '12px', cursor: 'pointer' }}>
              {i + 1}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminUsers;
